import { PostCheckoutMandatoryQuestionsInAppVariant } from '../../constants/statsig';
import { CheckoutState } from '../../state';
import { getPostCheckoutMandatoryQuestionsInApp } from '../../utils/statsig';
import { getIsPostCheckoutMandatoryQuestionsElegible } from './getIsPostCheckoutMandatoryQuestionsElegible';

export const getAreMandatoryCannedQuestionsAndOptionalQuestionsAskedAfterPayment =
    (state: CheckoutState) =>
        getIsPostCheckoutMandatoryQuestionsElegible(state) ||
        [
            PostCheckoutMandatoryQuestionsInAppVariant.optionalAndCannedQuestionsInApp,
            PostCheckoutMandatoryQuestionsInAppVariant.customQuestionsInApp,
        ].includes(getPostCheckoutMandatoryQuestionsInApp());
